export default {"src":"/uk/_next/static/media/spot-laptop.9c49cc5d.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};